import React from 'react';
import styles from './FadeIn.module.css';

interface Props {
  duration?: number;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const FadeIn = ({ duration = 0.5, children, style }: Props) => {
  return (
    <div
      className={styles.wrapper}
      style={{ ...style, '--fade-duration': `${duration}s` } as React.CSSProperties}
    >
      {children}
    </div>
  );
};
